import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import classNames from 'classnames';
import {transformForMenu} from '../services/category-transformer';
import {FormattedMessage} from 'react-intl';
import {execBI} from '../services/bi-events-manager';
import ErrorMessage from '../components/Error-message';
import ALink from '../components/ALink';
import {isExperiment} from '../config';

const handleHide = ev => {
  ev.preventDefault();
  browserHistory.goBack();
};

const handleClickBI = (slug) => {
  return () => {
    execBI('CATEGORY_LINK_CLICK', {category: slug, origin: 'menu'});
  };
};

class CategoriesPopup extends Component {

  renderSpecial() {
    const pending = this.props.pending;
    const developer = this.props.developer;

    if (developer.length || pending.length || isExperiment('specs.market.EditorMyAppsPage', this.props.experiments)) {
      return (
        <ul className="special">
          {developer.length ?
            <li className={classNames({'selected': this.props.openCategory === 'developer-apps'})}>
              <ALink to={'/developer/'} onClick={handleClickBI('developer-apps')}>
                <FormattedMessage id="category.developerApps.name"/>
              </ALink>
            </li> : ''}

          {pending.length ?
            <li className={classNames('category-pending', {'selected': this.props.openCategory === 'pending-apps'})}>
              <ALink to={'/pending/'} onClick={handleClickBI('pending-apps')}>
                <FormattedMessage id="category.pending.name"/>
                <span className="pending-apps-count notification-badge">{pending.length}</span>
              </ALink>
            </li> : ''}

          {isExperiment('specs.market.EditorMyAppsPage', this.props.experiments) && this.props.market !== 'standalone' ?
            <li className={classNames({'selected': this.props.openCategory === 'my-apps'})}>
              <ALink to={'/my-apps/'} onClick={handleClickBI('my-apps')}>
                My apps
              </ALink>
            </li> : ''}
        </ul>
      );
    }
  }

  render() {
    const categories = transformForMenu(this.props.items);

    return (
      <div className="navigation-popover">
        <div className={classNames('navigation-menu', {'with-pending': this.props.pending.length, 'with-developer': this.props.developer.length})}>

          <div className="navigation-menu-shadow" onClick={handleHide}></div>

          <div className="head">
            <button className="close" onClick={handleHide}></button>
          </div>

          <div className="body section section-pad">
            <h1 className="body-title"><FormattedMessage id="navigation.button.categories"/></h1>

            {this.renderSpecial()}

            {categories.length ?
              <ul className="categories">
                {categories.map((c, i) =>
                  <li key={i} className={classNames({'selected': c.slug === this.props.openCategory})}>
                    <ALink to={`/${c.slug}/`} onClick={handleClickBI(c.slug)}>{c.name}</ALink>
                  </li>
                )}
              </ul> :
              <ErrorMessage className="error-message-less-padding"/>
            }
          </div>

        </div>
      </div>
    );
  }
}

CategoriesPopup.propTypes = {
  items: PropTypes.array.isRequired,
  developer: PropTypes.array.isRequired,
  pending: PropTypes.array.isRequired,
  single: PropTypes.array.isRequired,
  openCategory: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  market: PropTypes.string,
  experiments: PropTypes.object
};

function mapStateToProps(state) {
  const items = state.categories.menu.items;
  const developer = state.appsByType.developer.items;
  const pending = state.appsByType.pendingInMarket.items;
  const single = state.appsByType.single.items;
  const openCategory = state.categories.openCategory;
  const market = state.mode.market;
  const experiments = state.mode.experiments;

  return {items, developer, pending, single, openCategory, market, experiments};
}

export default connect(mapStateToProps)(CategoriesPopup);



// WEBPACK FOOTER //
// ./containers/Categories-popup.js